import Input from "../../../components/Input/Input";
import {ReactComponent as InfoSvg} from "../../../assets/info.svg";
import Icon from "../../../components/Icon/Icon";
import {inputTypeOptions} from "../Elements/Settings/Settings";
import Select from "../../../components/Input/Select";
import {useFormik} from "formik";

const InputModal = ({handleChange, localSettings, modalRadioGroups, setModalRadioGroups, error}) => {
    const mapToVariable = (title) => {
        localSettings.variables = title.toLowerCase().replaceAll(" ", "_");
    }

    return (
        <>
            <Select
                name="inputType"
                label="Input type"
                value={inputTypeOptions.find(option => option.value === (localSettings.inputType || "Number"))}
                options={inputTypeOptions}
                handleChange={(selectedOption) => handleChange("inputType", selectedOption.value)}
            />

            <div>
                <Input
                    name="title"
                    label="Title"
                    value={localSettings.title || ""}
                    handleChange={(e) => {
                        handleChange("title", e.target.value)
                        mapToVariable(e.target.value);
                    }}
                    error={error === "Title is required" && error}
                />
            </div>

            {localSettings.inputType === "select" &&
                <Select
                    isCreatable
                    name="options"
                    label="Options"
                    placeholder="Add options"
                    value={localSettings.options}
                    options={localSettings.options}
                    handleChange={(options) => handleChange("options", options)}
                    required
                    isMulti
                    error={error === "Options are required" && error}
                />
            }

            {localSettings.inputType === "radio" &&
                <Select
                    isCreatable
                    name="radioGroup"
                    label="Group name"
                    placeholder="Add group name"
                    value={modalRadioGroups.find(option => option.value === localSettings.selectedRadioGroup.value)}
                    options={modalRadioGroups}
                    handleChange={(radioGroup) => {
                        if (radioGroup && !modalRadioGroups.find(option => option === radioGroup))
                            setModalRadioGroups(prev => [...prev, radioGroup])

                        handleChange("selectedRadioGroup", radioGroup);
                    }}
                    required
                    error={error === "Group name is required" && error}
                />
            }

            <div>
                <Input
                    name="description"
                    label="Description"
                    value={localSettings.description || ""}
                    handleChange={(e) => handleChange("description", e.target.value)}
                />
            </div>

            <div className="variables">
                <Input
                    type="checkbox"
                    layout="inline"
                    label="Variables"
                    name="hasVariable"
                    handleChange={(e) => handleChange("hasVariable", e.target.checked)}
                    checked={Boolean(localSettings.hasVariable)}
                />

                <div className="tooltip">
                    <Icon svg={InfoSvg} className="icon"/>
                    <span className="triangle"></span>
                    <span className="text">Automatically fills this field in future forms for the same client.</span>
                </div>
            </div>

            {localSettings.hasVariable && (
                <div>
                    <Input
                        name="variables"
                        layout="vertical"
                        value={localSettings.variables || ""}
                        readOnly
                        error={error}
                    />
                </div>
            )}

            <div>
                <Input
                    type="checkbox"
                    layout="inline"
                    label="Required"
                    name="required"
                    handleChange={(e) => handleChange("required", e.target.checked)}
                    checked={Boolean(localSettings.required)}
                />
            </div>
        </>
    )
}

export default InputModal;